<template>
  <PlainTable :sourceList="itemArray" :useExcel="true" ref="contentTable">
    <template #header>
      <caption>
        <span class="blind">두뇌톡톡 완료일수별 누적통계(최근 6개월,조회기간 무관)</span>
      </caption>
      <colgroup></colgroup>
      <thead class="table_list_head table_list_head_line">
        <tr>
          <th>완료일수</th>
          <th>대상자수</th>
          <th>호출건수</th>
          <th>완료건수</th>
          <th>평균점수</th>
        </tr>
      </thead>
    </template>
    <template #row="{rowData}">
      <tr>
        <td>{{periodTypeText[rowData.gamePeriodType]}}</td>
        <td class="right">{{rowData.recipientCount}}</td>
        <td class="right">{{rowData.requestCount}}</td>
        <td class="right">{{rowData.completeCount}}</td>
        <td class="right">{{rowData.averageScore}}</td>
      </tr>
    </template>
  </PlainTable>
</template>

<script>
export default {
  props: {
    itemArray: Array
  },
  data() {
    return {
      periodTypeText: {
        UNDER_10: "10일 미만 이용자",
        UNDER_20: "10일~19일 이용자",
        UNDER_30: "20일~29일 이용자",
        UNDER_40: "30일~39일 이용자",
        UNDER_50: "40일~49일 이용자",
        UNDER_60: "50일~59일 이용자",
        OVER_60: "60일 이상 이용자"
      }
    };
  }
};
</script>
